import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'
import { useQueryClient } from '@tanstack/react-query'

const useCreatePlatformAppClientMutation = createMutationHook(
  PlatformAppsApiClient.createPlatformAppClient,
  {
    mutationKey: ['createPlatformAppClient'],
  },
)

export const useCreatePlatformAppClient = () => {
  const queryClient = useQueryClient()
  const { createPlatformAppClientMutation } = useCreatePlatformAppClientMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['platformAppClients'] })
    },
  })

  return {
    createPlatformAppClient: createPlatformAppClientMutation.mutate,
    isLoading: createPlatformAppClientMutation.isLoading,
  }
}
